<template>
<v-toolbar flat class="mt-8">
  <v-row>
    <v-col cols="3" sm="10" v-if="!mid">
      <p class="mytitle primary--text">{{title}}</p>
    </v-col>
    <v-col cols="3" sm="10" v-if="mid">
      <v-alert prominent type="success" text shaped dark>
        <v-row align="center">
          <v-col class="grow"> {{title}}</v-col>
        </v-row>
      </v-alert>
    </v-col>
    <v-col cols="3" sm="2">
      <div class="text-center">

        <v-btn v-if="!mid && !showPrintLabelButton" fab small class="ma-2 white--text" color="success" type="submit">
          <v-icon dark>
            mdi-content-save
          </v-icon>
        </v-btn>

        <v-btn v-if="mid && !showPrintLabelButton" fab small class="mx-2 white--text" color="primary" v-shortkey="['enter']" @shortkey="telegram()" @click="telegram">
          <v-icon dark>mdi-send</v-icon>
        </v-btn>

        <v-btn v-if="showPrintLabelButton" fab small class="mx-2 white--text" color="grey darken-4" v-shortkey="{fa: ['ctrl'+'ح'], en: ['ctrl'+'p']}" @shortkey="printAllLabels()" @click="printAllLabels">
          <v-icon dark>mdi-printer-pos</v-icon>
        </v-btn>

        <v-btn fab small class="ma-2 white--text" color="grey" v-shortkey="['esc']" @shortkey="back()" to="/">
          <v-icon dark>mdi-logout-variant</v-icon>
        </v-btn>

      </div>
    </v-col>
  </v-row>

</v-toolbar>
</template>

<script>
//
import MySendToTelegram from '../../functions/sendToTelegram'

export default {
  name: 'AddButtons',
  props: ['mid', 'labelData', 'showPrintLabelButton'],
  // data: () => ({}),
  beforeCreate() {
    this.route = this.$store.getters.pageInfo.route
    this.formTitle = this.$store.getters.pageInfo.formTitle
  },
  computed: {
    title() {
      if (this.showPrintLabelButton) return 'چاپ لیبل...'
      const isAdd = this.$route.path.split('/')[2] === 'add'
      const isSaved = !!this.mid

      const action = isAdd ? 'add' : 'edit'
      const messages = {
        add: isSaved ?
          `${this.formTitle} جدید با موفقیت ثبت شد` : `صدور ${this.formTitle} جدید...`,
        edit: isSaved ?
          `اطلاعات ${this.formTitle} با موفقیت ویرایش شد` : `ویرایش ${this.formTitle}...`,
      }

      return messages[action]
    }
  },
  methods: {
    async telegram() {
      try {
        await MySendToTelegram(this.mid);
        this.back();
      } catch (e) {
        console.error('ارسال به تلگرام ناموفق بود:', e)
      }
    },

    printAllLabels() {
      this.$emit('child-print-all')
    },

    back() {
      const CheckRoute = ['invoices', 'lendings'].includes(this.route)
      const checkLendingValue = !this.labelData?.items?.some(i => i?.lending_value)
      const checkSale = this.labelData?.type === 'sale'
      const checkPay = this.labelData?.type === 'pay'
      //
      const canPrint = CheckRoute && this.mid && (checkLendingValue && checkSale || checkPay)
      this.$router.push(
        canPrint ?
        `/${this.route}/printLabel/${this.mid}` :
        '/'
      )
      // console.log(this.isDirty);
      // if (this.isDirty) {
      //   const result = window.confirm('تغییراتی اعمال شده، آیا می‌خواهید سند ذخیره شود؟')
      //   if (result) {
      //     this.$emit('onSave', {
      //       esc: true
      //     })
      //   } else {
      //     const res = window.confirm('آیا مایلید بدون ذخیره کردن از سند خارج شوید؟')
      //     if (res) this.$router.go(-1)
      //   }
      // } else {
      //   this.$router.go(-1)
      // }
      //
    }
  },
}
</script>
